<template>
    <div :class="imgPlayer">
    </div>
</template>
<style scoped>
.femmePlayer {
        background-image: url("../assets/femmePlayer.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .playerOK {
        background-image: url("../assets/playerOK.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .adoPlayer {
        background-image: url("../assets/adoPlayer.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .player1 {
        background-image: url("../assets/player1.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .player0 {
        background-image: url("../assets/player0.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .vieuxPlayer {
        background-image: url("../assets/vieuxPlayer.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .player3Forme {
        background-image: url("../assets/player3Forme.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100px;
        width: 140px;        
        display: inline-block;

    }
    .playerForme {
        background-image: url("../assets/playerForme.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100px;
        width:  100px;       
        display: inline-block;
    }
    .onePlayer {
        background-image: url("../assets/onePlayer.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
        
        
    }
    .twoPlayer {
         background-image: url("../assets/doublettePlayer.png");
         background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .threePlayer {
        background-image: url("../assets/triplettePlayer.png");
          background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
    .tournoiWithoutElim {
        background-image: url("../assets/tournoi_tableau.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 400%;        
        display: inline-block;
        margin-top: 10px;
        margin-left: 10px;
    }
    .tournoiGG {
        background-image: url("../assets/tournoi_gg.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 400%;        
        display: inline-block;
        margin-top: 10px;
        margin-left: 10px;
    }
    .tournoiWithElim {
        background-image: url("../assets/tournoi_championnat.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 400%;        
        display: inline-block;
        margin-top: 10px;
    }
</style>
<script >

export default {
     props: ["classes", "change", "animation"],
     data() {
         return  {
             imgPlayer: null,
             timeOut: 0
         }
     },
     watch: {
         animation() {
             if (this.animation)
                this.changeClass();
            else    
                clearTimeout(this.timeOut);
         }
     },
     methods: {
        random(min, max) {
            return Math.floor(min + Math.random() * (max - min));
        },
        initImage() {
            var max =this.classes.length;
            if (max>0) {
                var i = this.random(0,max);
                this.imgPlayer = this.classes[i];
                return true;
            }
            else 
                return false;
        },
        changeClass() {
            var delay = this.change * 100;
            this.timeOut = setTimeout(
                p=>{
                var goLoop = false;
                if (this.classes != null) {
                    goLoop = this.initImage();        
                }
                if (goLoop && this.change>0)
                    this.changeClass();
                }
                , delay
            )
        },
     },
     mounted() {
         this.initImage();
         if (this.animation)
                this.changeClass();
            else    
                clearTimeout(this.timeOut);
    }
}
</script>